module.exports = __webpack_public_path__ + "img/rosa_sudeck_preview.cb013811.png";